import { AdminLayout } from "layout/AdminLayout"

export const AdminReportsPage = () => {
    return (
        <AdminLayout>
            Admin Reports Page
        </AdminLayout>
    )
}